import { Check, Close, Minus } from "@dreamhub/designsystem/icons";
import IconContainer from "@/components/ui/icon-container";
import { cn } from "@/utils/utils";
import { IcpFitDetailBulletStatus } from "@/entities/icpFit/types";

export type { IcpFitDetailBullet, IcpFitDetailBulletStatus } from "@/entities/icpFit/types";

const STATUS_STYLES: Record<IcpFitDetailBulletStatus, string> = {
  pass: "border-charts-positive text-charts-positive",
  fail: "border-charts-negative text-charts-negative",
  not_assessed: "border-field-default text-disabled"
};

const STATUS_ICONS: Record<IcpFitDetailBulletStatus, React.ReactNode> = {
  pass: <Check />,
  fail: <Close />,
  not_assessed: <Minus />
};

const BulletIcon: React.FC<{ status: IcpFitDetailBulletStatus }> = ({
  status
}) => {
  return (
    <div
      className={cn(
        "flex items-center justify-center size-5 rounded-full shrink-0 border",
        STATUS_STYLES[status]
      )}
    >
      <IconContainer size="xs" color="current">
        {STATUS_ICONS[status]}
      </IconContainer>
    </div>
  );
};

export default BulletIcon;
